var I = Object.defineProperty, P = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var b = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var C = (o, e, s) => e in o ? I(o, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : o[e] = s, r = (o, e) => {
  for (var s in e || (e = {}))
    b.call(e, s) && C(o, s, e[s]);
  if (l)
    for (var s of l(e))
      y.call(e, s) && C(o, s, e[s]);
  return o;
}, a = (o, e) => P(o, U(e));
var n = (o, e) => {
  var s = {};
  for (var t in o)
    b.call(o, t) && e.indexOf(t) < 0 && (s[t] = o[t]);
  if (o != null && l)
    for (var t of l(o))
      e.indexOf(t) < 0 && y.call(o, t) && (s[t] = o[t]);
  return s;
};
import { jsx as m, jsxs as D } from "react/jsx-runtime";
import { r as F } from "./rem-CMQJ_ZTp.js";
import { forwardRef as M } from "react";
import { e as V, c as Z } from "./get-size-Bc1Pz5yf.js";
import { c as k } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as q } from "./factory-ueRxoNOV.js";
import { u as A } from "./use-styles-DToiHEa6.js";
import { p as E } from "./polymorphic-factory-DufevJAl.js";
import { U as G } from "./UnstyledButton-D9OCzDhz.js";
const h = M(
  (d, t) => {
    var i = d, { size: o = "var(--cb-icon-size, 70%)", style: e } = i, s = n(i, ["size", "style"]);
    return /* @__PURE__ */ m(
      "svg",
      a(r({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: a(r({}, e), { width: o, height: o }),
        ref: t
      }, s), {
        children: /* @__PURE__ */ m(
          "path",
          {
            d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          }
        )
      })
    );
  }
);
h.displayName = "@mantine/core/CloseIcon";
var L = { root: "m_86a44da5", "root--subtle": "m_220c80f2" };
const H = {
  variant: "subtle"
}, J = k((o, { size: e, radius: s, iconSize: t }) => ({
  root: {
    "--cb-size": Z(e, "cb-size"),
    "--cb-radius": s === void 0 ? void 0 : V(s),
    "--cb-icon-size": F(t)
  }
})), g = E((o, e) => {
  const s = q("CloseButton", H, o), v = s, {
    iconSize: t,
    children: d,
    vars: i,
    radius: K,
    className: w,
    classNames: B,
    style: R,
    styles: x,
    unstyled: p,
    "data-disabled": u,
    disabled: c,
    variant: f,
    icon: z,
    mod: S,
    __staticSelector: _
  } = v, N = n(v, [
    "iconSize",
    "children",
    "vars",
    "radius",
    "className",
    "classNames",
    "style",
    "styles",
    "unstyled",
    "data-disabled",
    "disabled",
    "variant",
    "icon",
    "mod",
    "__staticSelector"
  ]), j = A({
    name: _ || "CloseButton",
    props: s,
    className: w,
    style: R,
    classes: L,
    classNames: B,
    styles: x,
    unstyled: p,
    vars: i,
    varsResolver: J
  });
  return /* @__PURE__ */ D(
    G,
    a(r(a(r({
      ref: e
    }, N), {
      unstyled: p,
      variant: f,
      disabled: c,
      mod: [{ disabled: c || u }, S]
    }), j("root", { variant: f, active: !c && !u })), {
      children: [
        z || /* @__PURE__ */ m(h, {}),
        d
      ]
    })
  );
});
g.classes = L;
g.displayName = "@mantine/core/CloseButton";
export {
  g as C
};
